import React from "react";
import PageHeader from "../components/PageHeader";
import TeamComponent from "../components/Team";
const Team = () => {
  return (
    <>
      <PageHeader title="Team" />
      <TeamComponent />
    </>
  );
};

export default Team;
